<template>
  <div>
    <el-select
      v-model="value"
      :placeholder="
        params.filterParams.opertype === 3 ? '列表搜索' : '列表过滤'
      "
      size="mini"
      filterable
      :key="params.column.colId"
      clearable
      @change="handleChange"
      :popper-class="
        isHeader
          ? 'ag-table-float-el-select-popper show-header'
          : 'ag-table-float-el-select-popper'
      "
      class="ag-table-float-el-select"
    >
      <div class="ag-table-float-el-select-header" v-if="isHeader">
        <el-checkbox v-model="checkAll" @change="handleCheckBoxChange"
          >显示禁用</el-checkbox
        >
      </div>
      <!-- <template #header v-if="isHeader">
      <el-checkbox v-model="checkAll" @change="handleCheckBoxChange"
        >显示禁用</el-checkbox
      >
    </template> -->
      <el-option
        :key="index"
        :label="item.name"
        :value="item.name"
        v-for="(item, index) in currentOptions"
      >
        <span
          v-if="parseInt(item.ison) === 0"
          style="text-decoration: line-through; font-style: italic"
          >{{ item.name }}</span
        >
        <span v-else>{{ item.name }}</span>
      </el-option>
    </el-select>
  </div>
</template>
<script>
export default {
  data () {
    return {
      value: '',
      checkAll: false
    }
  },
  computed: {
    options () {
      return this.params.filterParams.list || []
    },
    ableOptions () {
      return this.options.filter(item => parseInt(item.ison) === 1)
    },
    isHeader () {
      return (
        this.ableOptions.length && this.ableOptions.length < this.options.length
      )
    },
    currentOptions () {
      return this.isHeader
        ? this.checkAll
          ? this.options
          : this.ableOptions
        : this.options
    }
  },
  methods: {
    handleCheckBoxChange () {
      if (this.value) {
        this.value = ''
        this.handleChange()
      }
    },
    handleChange () {
      if (this.value) {
        this.params.parentFilterInstance(instance => {
          instance.onFloatingFilterChanged('contains', this.value === '全部' ? '' : this.value)
        })
      } else {
        this.params.parentFilterInstance(instance => {
          instance.onFloatingFilterChanged('contains', null)
        })
      }
      if (this.params.filterParams.opertype === 3) {
        this.params.enter()
      }
    },
    onParentModelChanged (parentModel, event) {
      // When the filter is empty we will receive a null value here
      if (!parentModel) {
        this.value = ''
      } else {
        this.value = parentModel.filter
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep.ag-table-float-el-select {
  position: absolute;
  left: 0;
  top: 0;
  width: calc(100% - 1px);

  .el-input__inner {
    height: 29px;
    border-radius: 0;
    border-color: transparent;
    padding: 1px 7px !important;
    &:focus {
      border-color: #32b16c;
    }
  }
  .el-input__suffix {
    .el-icon-arrow-up {
      display: none;
    }
  }
}
</style>
<style lang="scss">
.ag-table-float-el-select-popper {
  .ag-table-float-el-select-header {
    padding: 10px;
    width: 100%;
    border-bottom: 1px solid #e4e7ed;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 999999;
    background: #fff;
    .el-checkbox {
      align-items: center;
    }
  }
  &.show-header {
    min-width: 140px !important;
    .el-scrollbar__view {
      padding-top: 45px;
    }
  }
  &.show-headers {
    min-width: 186px !important;
    .el-scrollbar__view {
      padding-top: 45px;
    }
  }
}
</style>
